shadow$provide[336] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Debug:{enumerable:true, get:function() {
  return Debug;
}}});
var require$three = require("three");
var require$_DOT__SLASH_base_DOT_js = require("./base.js");
class Debug extends require$_DOT__SLASH_base_DOT_js.Base {
  constructor(renderer, shaders, options) {
    super(renderer, shaders, options);
    this.geometry = new require$three.PlaneGeometry(1, 1);
    this.material = new require$three.MeshBasicMaterial({map:options.map});
    this.material.side = require$three.DoubleSide;
    const object = new require$three.Mesh(this.geometry, this.material);
    object.position.x += options.x || 0;
    object.position.y += options.y || 0;
    object.frustumCulled = false;
    object.scale.set(2, 2, 2);
    object.__debug = true;
    this.objects = [object];
  }
  dispose() {
    this.geometry.dispose();
    this.material.dispose();
    this.objects = this.geometry = this.material = null;
    return super.dispose();
  }
}

};